module.exports = __webpack_public_path__ + "img/insta_logo.fbb06745.png";